"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvince = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var SearchProvince = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SearchProvince, _super);
    function SearchProvince() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取省列表接口';
        _this.code = '101065';
        _this.desc = '获取省列表接口';
        _this.requestParams = new bankCard_1.SearchProvinceRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SearchProvince;
}(service_1.BaseService));
exports.SearchProvince = SearchProvince;
//# sourceMappingURL=searchProvince.js.map